module.exports = __webpack_public_path__ + "static/media/hamburguesa.22e0b1e9.svg";